module.exports = __webpack_public_path__ + "static/media/recipe_category_10.5422535b.png";